export const environment = {
    production: false,
    title: 'Dev Environment Heading',
    apiURL: 'https://staging.saleko.ng/api/main-svc',
    apiURL2: 'https://staging.saleko.ng/api/main-svc-v2',
    apiLoginURL: 'https://staging.saleko.ng/api/auth-svc',
    STAFF_STORAGE_KEY: 'staging',
  imageURL: 'https://addosser-hehhcbapggbaeuae.z03.azurefd.net/atlasfiles'
    // accountApiURL: 'https://staging.atlas.ng/accounting-svc'
  };